import './InviteAgents.scss'

import React from 'react'
import { connect } from 'react-redux'
import OpButton from 'common/views/components/OpButton'
import OpDropdownButton from 'common/views/components/OpDropdownButton'
import moment from 'moment-timezone'

import AddAgentRow from './AddAgentRow'
import ExperienceLevelTipModal from 'common/views/components/ExperienceLevelTipModal'
import RecommendBadge from 'common/views/components/RecommendBadge'
import {
  addAgentInvite,
  postAgentInvites,
  removeSelectedAgent,
  bulkValidateAgentEmail,
  selectAllAgentInvites,
  unselectAllAgentInvites,
  editSelectedAgentInvites,
} from 'broker/redux/manage_users'
import {
  selectAgentInvitesListItems,
  selectSelectedCount,
  selectAgentFormErrors,
  selectSearchResults,
  selectIsSendingAgentInvites,
  selectHasAgentRecommendations,
  selectNonEmptySelectedAgentInviteCount,
  selectTotalNonEmptyAgentInvites
} from 'broker/selectors/manage_users'

import OpSearchbox from 'common/views/components/OpSearchbox'
import OpCheckbox from 'common/views/components/OpCheckbox'

import { AGENT_EXPERIENCE_LEVELS_SHORT } from 'common/constants'

import { segmentEventTracker } from 'common/analytics'

const SEARCH_KEYS = [
  'agent_best_name',
  'agent_email',
  'agent_phone',
  'agent_address_city',
  'agent_address_line_1',
  'agent_address_zip'
]

const MANUAL_SEGMENT_PAGE = 'invite-agents'

const itemToFormatString = item => {
  const addressCity = _.filter([item.agent_address_line_1, item.agent_address_city], i => !!i).join(', ')
  const fullAddress = _.filter([addressCity, item.agent_address_state, item.agent_address_zip], i => !!i).join(' ')
  return _.filter([item.agent_best_name, item.agent_email, item.agent_phone, fullAddress], i => !!i).join(' - ')
}

const renderSearchItem = (item) => (
  <div className="agent-search-result-row">
    <span>{itemToFormatString(item)}</span>
  </div>
)

const ToggleArrow = ({ open }) => (
  <i className={`fa ${open ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'} toggle-icon`}/>
)

class BulkAddSection extends React.Component {
  constructor(props) {
    super(props)

    this.setTextAreaRef = this.setTextAreaRef.bind(this)
  }

  state = {
    emailList: ''
  }

  setTextAreaRef(ref) {
    this.textAreaRef = ref
  }

  render() {
    const { onBulkAdd } = this.props
    return (
      <div className={'bulk-add-section'}>
        <div className={'-instructions'}>
          <h3>Copy & paste addresses separated by commas or semi-colons.</h3>
        </div>
        <div className={'-input'}>
          <textarea
            placeholder={'agent1@email.com, agent2@email.com, …'}
            onChange={evt => this.setState({emailList: evt.target.value})}
            ref={this.setTextAreaRef}
          />
        </div>
        <div className={'-submit'}>
          <button onClick={() => {
            onBulkAdd(this.state.emailList)
            this.setState({emailList: ''})
            this.textAreaRef.value = ''
          }}>
            <i className="fa fa-plus-circle" style={{fontSize: 20}}/> Add to list
          </button>
        </div>
      </div>
    )
  }
}

class InviteAgents extends React.Component {
  componentDidUpdate(prevProps) {
    const prevInvites = prevProps.agentInvites
    const { agentInvites, dispatch } = this.props

    if (prevInvites !== agentInvites && !agentInvites.length) {
      dispatch(addAgentInvite({selected: true}))
    }
  }

  state = {
    bulkAdding: false
  }

  handleBulkAdd = emailAddresses => {
    const { addInvite, bulkValidateAgentEmail, isCore, isMVIP } = this.props

    const toParse = emailAddresses.replace(/[;,\s]+/g, ',')
    const emailsList = _.reverse(toParse.split(','))        // Reverse it so the items show up in the same order they are entered in
    const now = moment().format('x')

    _.forEach(emailsList, (email, idx) => {
      if (!email) {
        return
      }
      const item = {email, selected: true, suggested: false, is_core_enabled: isCore, is_mvip_enabled: isMVIP, key: `${now}-${idx}`}
      addInvite(item)
    })

    bulkValidateAgentEmail()

    segmentEventTracker('User Added', {
      'was_bulk': true,
      'user_type': 'agent',
      'from_search': false,
      'amount_added': emailsList.length
      //TODO: add property for amount added without error
    }, _, MANUAL_SEGMENT_PAGE)

  }

  render() {
    const {
      handleBack,
      isCore,
      isMVIP,
      isRCCOnly,
      invites,
      selected_count,
      inviteAgents,
      hasAgentRecommendations,
      removeSelectedInvites,
      addInvite,
      formErrors,
      rawAgentData,
      sendingInvites,
      nonEmptySelectedAgentCount,
      totalNonEmptyAgentCount,
      selectAllAgentInvites,
      unselectAllAgentInvites,
      editSelectedAgentInvites,
      brokerApmInviteExpirationEnabled
    } = this.props
    return (
      <div className="InviteAgents">
        <span className="back-button" onClick={handleBack}>{'< Back'}</span>
        <div className={`InviteAgents--body ${isRCCOnly ? 'InviteAgents--body-short': ''}`}>

          { /******* HEADING SECTION *******/}
          <div className="heading-wrapper">
            <div className="heading">
              <div className="-icon"><i className="fa fa-user-plus" aria-hidden="true"/></div>
              <div className="-title">Invite Agents</div>
            </div>
            <div className="heading-details-row">
              <div className="left-col">
                <div className="agent-invite-count">{`Invite Agents (${nonEmptySelectedAgentCount} of ${totalNonEmptyAgentCount})`}</div>
              </div>
              <div className="right-col">
                <OpDropdownButton
                  items={AGENT_EXPERIENCE_LEVELS_SHORT}
                  onOptionSelect={(experience_level) => editSelectedAgentInvites({experience_level: experience_level.value, experienceLevelErrorMessage: null})}
                  getLabelFromItem={(experience_level) => experience_level.label}
                  buttonLabel={<i className="fa fa-ellipsis-h" aria-hidden="true"/>}
                  hidden={!selected_count}
                  className={'EditSelectedInvitesDropdown'}
                />
                { !!selected_count && <OpButton bsStyle="secondary-black" disabled={selected_count !== 1} onClick={removeSelectedInvites}>Remove</OpButton> }
                <OpButton
                  bsStyle="primary-green"
                  disabled={!selected_count || formErrors}
                  onClick={() => {
                    inviteAgents()

                    segmentEventTracker('User Invited', {
                      'user_type': 'agent',
                      'amount_added': selected_count
                    })
                  }}
                  pending={sendingInvites}
                >
                  Invite agents
                </OpButton>
              </div>
            </div>
          </div>

          { /******* SEARCH/ADD/SELECT ALL *******/}
          <div className="list-actions-wrapper">
            <div className="select-all-row">
              <OpCheckbox
                label={'Select All'}
                labelClass={'select-all-agents'}
                checked={ selected_count === invites.length }
                onChange={() => {
                  if (selected_count !== invites.length) {
                    selectAllAgentInvites()
                  } else {
                    unselectAllAgentInvites()
                  }
                }}
              />
            </div>

            {hasAgentRecommendations && <div className="-recommended-instructions">
              <div className="icon-container"><RecommendBadge /></div>
              <div><strong>Recommended agents</strong> shown at the top are agents more likely to succeed on Opcity given their experience level and connection with your brokerage.</div>
            </div>}

            <div className="search-box-row">
              <div className="search-box" onClick={() => {
                segmentEventTracker('User Searched', {
                  'user_type': 'agent'
                })
              }}>
                <OpSearchbox
                  placeholder="Find agent on realtor.com"
                  searchKeys={SEARCH_KEYS}
                  searchSource={rawAgentData}
                  renderItem={renderSearchItem}
                  onSelectResult={r => {
                    addInvite({ ...r, selected: true, suggested: true, is_core_enabled: isCore, is_mvip_enabled: isMVIP, key: moment().format('x') })

                    segmentEventTracker('User Added', {
                      'was_bulk': true,
                      'user_type': 'agent',
                      'from_search': true,
                      'amount_added': 1
                    }, _, MANUAL_SEGMENT_PAGE)
                  }}
                />
              </div>
              <div className="add-agent-button"  onClick={() => {
                addInvite({selected: true, suggested: false, is_core_enabled: isCore, is_mvip_enabled: isMVIP})

                segmentEventTracker('User Added', {
                  'was_bulk': false,
                  'user_type': 'agent',
                  'from_search': false,
                  'amount_added': 1
                }, _, MANUAL_SEGMENT_PAGE)
              }}>
                <i className="fa fa-plus-circle" style={{fontSize: 20}}/> Add new
              </div>
            </div>
          </div>

          {/******* BULK INVITE *******/}
          <div className={'bulk-upload-wrapper'}>
            <button
              className={'-toggle-bulk'}
              onClick={() => {
                this.setState({bulkAdding: !this.state.bulkAdding})
              }}
            >
              Bulk upload email addresses<ToggleArrow open={this.state.bulkAdding}/>
            </button>
            { !!this.state.bulkAdding && <BulkAddSection onBulkAdd={this.handleBulkAdd} /> }
          </div>
          {/******* INVITE EXPIRATION WARNING *******/}

          {brokerApmInviteExpirationEnabled && <div className={'expiration-warning-wrapper'}>
              <div className={'expiration-warning-content'}>
                <i className="fa fa-info-circle" style={{fontSize: 24}}/>
                <span>Invite will expire 4 weeks from the date of send.</span>
              </div>

            </div>
          }

          {/******* AGENT ROWS *******/}
          {_.map(invites, (invite, idx) => <AddAgentRow invite={invite} key={invite.key} isCore={isCore} isMVIP={isMVIP} isRCCOnly={isRCCOnly} idx={idx} />)}

        </div>
        <ExperienceLevelTipModal/>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  invites: selectAgentInvitesListItems(state),
  selected_count: selectSelectedCount(state),
  totalNonEmptyAgentCount: selectTotalNonEmptyAgentInvites(state),
  nonEmptySelectedAgentCount: selectNonEmptySelectedAgentInviteCount(state),
  formErrors: selectAgentFormErrors(state),
  rawAgentData: selectSearchResults(state),
  sendingInvites: selectIsSendingAgentInvites(state),
  hasAgentRecommendations: selectHasAgentRecommendations(state)
})

const mapDispatchToProps = dispatch => ({
  dispatch,
  inviteAgents: () => dispatch(postAgentInvites()),
  removeSelectedInvites: () => dispatch(removeSelectedAgent()),
  addInvite: body => dispatch(addAgentInvite(body)),
  bulkValidateAgentEmail: () => dispatch(bulkValidateAgentEmail()),
  selectAllAgentInvites: () => dispatch(selectAllAgentInvites()),
  unselectAllAgentInvites: () => dispatch(unselectAllAgentInvites()),
  editSelectedAgentInvites: updates => dispatch(editSelectedAgentInvites(updates)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InviteAgents)
